import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import axios from '../../../utils/axios';
const initialState = {
  isLoading: false,
  error: null,
  shippers: [],
};
const shippersSlice = createSlice({
  name: 'retailerShippers',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    stopLoading(state) {
      state.isLoading = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getShippers(state, action) {
      
      state.isLoading = false;
      state.shippers = action.payload;
    },
  },
});

export default shippersSlice.reducer;

export function getAllShippers() {

  axios.get('/retailer_app/api/v1/retailer/shippers').then((response) => {
    const { data } = response.data;
    dispatch(shippersSlice.actions.getShippers(data));
    dispatch(shippersSlice.actions.stopLoading());
  });
}
